import { Component, ViewEncapsulation } from '@angular/core';
import { BaseView } from '../base-view/base-view.directive';
import { DragDropDirective } from '../../directives/drag-drop.directive';
import { NgClass } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDragPreview, CdkDropList, CdkDragPlaceholder } from '@angular/cdk/drag-drop';
import { INode } from '../../shared/types';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FolderNamePipe } from '../../shared/folder-name.pipe';

@Component({
  selector: 'nxe-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [DragDropDirective, NgClass, TablerIconsModule,
    CdkDragHandle,
    CdkDrag,      // Importa CdkDrag direttamente
    CdkDropList,  // Importa CdkDropList direttamente
    CdkDragPreview,
    CdkDragPlaceholder,
    TranslateModule,
    MatTooltipModule,
    FolderNamePipe,
  ]

})
export class IconsComponent extends BaseView {

  public readonly icons = {
    node: 'folder',
    leaf: 'nxe-doc',
  };

  constructor() {
    super();
  }

}
